import { useCallback } from 'react'
import { useAdsConfigFetch } from '@mwxltd/flix-api-client'
import { fetchBannerAdDecision } from './helpers/fetchBannerAdDecision.js'
import { makeAdPlacementQueryData } from './helpers/getAdPlacementQueryData.js'

export const useFetchBannerAdDecision = () => {
  const fetchAdsConfig = useAdsConfigFetch()

  return useCallback(
    async (placementConfig, extendedData) => {
      const adsConfig = await fetchAdsConfig()
      const adConfig = makeAdPlacementQueryData(adsConfig?.common, placementConfig, extendedData)
      return fetchBannerAdDecision(adConfig)
    },
    [fetchAdsConfig],
  )
}
